import React, { forwardRef } from 'react';

import { InputAdornment, TextField, TextFieldProps } from '@mui/material';
import { IMaskInput } from 'react-imask';
import { Control, Controller, FieldPath, FieldPathValue } from 'react-hook-form';
import { Recipe } from '../../services/api/models';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';


interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}


const TextMaskCustom = forwardRef<HTMLInputElement, CustomProps>(
  function TextMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="HHh MMm"
        lazy={false}
        unmask={true}
        overwrite={true}
        type='text'
        blocks={{
          HH: {
            mask: '00',
            from: 0,
            to: 23,
            placeholderChar: '0',
          },
          MM: {
            mask: '00',
            from: 0,
            to: 59,
            placeholderChar: '0',
          },
        }}
        inputRef={ref}
        onAccept={(value: string) =>  onChange({ target: { name: props.name, value } })}
      />
    );
  },
);

interface DurationFieldProps {
  name: FieldPath<Recipe>
  control: Control<Recipe>,
}


export function DurationField(props: TextFieldProps & DurationFieldProps) {

  const format = (value: string) => {
    const str = value
    if (str.length == 1) {
      return `${str}0:00:00`;
    } else if (str.length == 2) {
      return `${str}:00:00`;
    } else if (str.length === 3) {
      const h = str.substring(0,2);
      const m = str.substring(2)
      return `${h}:${m}0:00`;
    } else if (str.length == 4) {
      const h = str.substring(0,2);
      const m = str.substring(2)
      return `${h}:${m}:00`;
    }

    return '00:00:00';
  };

  const parse = (value: FieldPathValue<Recipe, FieldPath<Recipe>>) => {
    const str = value?.toString();
    if(str && str.length === 8) {
      const s =  str.substring(0,5).replace(':', '');
      return s;
    }

    return '';
  };

  return (
    <Controller
      name={props.name}
      control={props.control}
      render={({
        field: {value, onChange},
      }) => (
        <TextField
          {...props}
          value={parse(value)}
          onChange={(event) => onChange(format(event.target.value))}
          id="formatted-text-mask-input"
          InputProps={{
            inputComponent: TextMaskCustom as any, // eslint-disable-line
            startAdornment: (
              <InputAdornment position="start">
                <AccessAlarmIcon />
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  );
};
